import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { QueryProvider } from './contexts/QueryContext';
import { ProtectedRoute } from './components/ProtectedRoute';

// Auth pages
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ConfirmSignUpPage } from './pages/ConfirmSignUpPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';

// Main pages
import { DashboardPage } from './pages/DashboardPage';

// Admin pages
import { UserManagementPage } from './pages/admin/UserManagementPage';
import { BudgetDashboardPage } from './pages/admin/BudgetDashboardPage';
import { CostReportsPage } from './pages/admin/CostReportsPage';
import { StorageManagementPage } from './pages/admin/StorageManagementPage';

function App() {
  return (
    <QueryProvider>
      <AuthProvider>
        <Router>
          <div className="app">
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/confirm-signup" element={<ConfirmSignUpPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />

              {/* Protected routes */}
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                }
              />

              {/* Admin routes - System Admin only */}
              <Route
                path="/admin/users"
                element={
                  <ProtectedRoute requireSystemAdmin>
                    <UserManagementPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/budget"
                element={
                  <ProtectedRoute requireSystemAdmin>
                    <BudgetDashboardPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/costs"
                element={
                  <ProtectedRoute requireSystemAdmin>
                    <CostReportsPage />
                  </ProtectedRoute>
                }
              />

              {/* Admin routes - Storage Admin only */}
              <Route
                path="/admin/storage"
                element={
                  <ProtectedRoute requireStorageAdmin>
                    <StorageManagementPage />
                  </ProtectedRoute>
                }
              />

              {/* Default redirect */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              
              {/* Catch all - redirect to dashboard */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </QueryProvider>
  );
}

export default App;
